<template>
  <!-- <div class="Platin" id="card"> -->
  <div class="overlay-bronze" :class="card" id="card">
    <!-- <figure class="card__figure">
      <img src="/img/logo-symbol.png" class="card__figure--logo" />
    </figure>
    <div class="card__reader">
      <div class="card__reader--risk card__reader--risk-one"></div>
      <div class="card__reader--risk card__reader--risk-two"></div>
      <div class="card__reader--risk card__reader--risk-three"></div>
      <div class="card__reader--risk card__reader--risk-four"></div>
    </div> -->
    <!-- <p v-if="getSegment == 'Platin'" class="card__type">پلاتینی</p>
    <p v-if="getSegment == 'Gold'" class="card__type">کارت طلایی</p>
    <p v-if="getSegment == 'Silver'" class="card__type">کارت نقره ای</p>
    <p v-if="getSegment == 'Bronze'" class="card__type">کارت برنزی</p> -->
    <p class="user__segment">تالار خشایارشا</p>
    <p class="user__email">{{ getClubnumber }}</p>
    <!-- <p class="user__email">{{ email }}</p> -->
    <p class="user__name">{{ name }}</p>

  </div>
</template>

<script>
export default {
  name: "LoyaltyCard",
  data: function () {
    return {
      segment: "bronz",
      email: "",
      name: "",
      card: "",
      clubnumber: 0,
    };
  },
  created() {
    this.setData();
  },
  computed: {
    getSegment() {
      return this.$store.getters.GetCustomerClubData.segment;
    },
    getClubnumber() {
      return this.$store.getters.GetCustomerClubData.id;
    },
  },
  mounted() {
    // Can accept an Object of options
    //     this.$toast.open({
    //         message: "کارت باشگاه شما آماده است",
    //         type: "success",
    //         duration: 3300,
    //         position:"top",
    //     });
  },

  methods: {
    async setData() {
      this.email = localStorage.getItem("Email");
      this.name = localStorage.getItem("Username");
      // this.card = this.$store.getters.GetCustomerClubData.segment;
      // this.segment = this.$store.getters.GetCustomerClubData.segment;

      return this.card;
    },
  },
  // destroyed() {
  //   this.$store.commit("SetUserScore", "");
  //   this.$store.commit("SetUserSegment", "");
  // },
};
</script>

<style>
:root {
  --platinColor1: rgb(229, 228, 226);
  --platinColor2: rgb(248, 245, 240);
  --goldColor1: rgb(255, 215, 0);
  --goldColor2: rgb(241, 207, 13);
  --silverColor1: rgb(192, 192, 192);
  --silverColor2: rgb(233, 231, 231);
  --bronzeColor1: rgb(173, 104, 36);
  --bronzeColor2: rgb(253, 250, 246);
  --height: 252px;
  --width: 400px;
}
#card {
  --heightCalc: -calc((var(--height) / 2) - 10px);
  --widthCalc: calc(var(--width) / 2);
  height: var(--height);
  width: var(--width);
  min-width: var(--width);
  border-radius: 15px;
  -webkit-filter: drop-shadow(2px 1px 2px rgba(0, 0, 0, 0.3));
  filter: drop-shadow(2px 1px 2px rgba(0, 0, 0, 0.3));

  background-size: cover;
  background-repeat: no-repeat;
  margin-top: -70px;
  position: relative;
}
#card.overlay-bronze {
  background-image: url(/img/clubcardIIIbronze2.jpg);
}
giftBronze.jpg
/* #card.overlay-bronze::after{
content: " ";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 14px;
    background: rgba(205, 127, 50, 0.4);

} */
.Platin {
  background: linear-gradient(90deg, var(--platinColor1), var(--platinColor2));
}
.Gold {
  background: linear-gradient(90deg, var(--goldColor1), var(--goldColor2));
}
.Silver {
  background: linear-gradient(90deg, var(--silverColor1), var(--silverColor2));
}
.Bronze {
  background: linear-gradient(10deg, var(--bronzeColor1), var(--bronzeColor2));
}
.card__figure--logo {
  width: 55px;
  position: relative;
  right: 15px;
  top: 15px;
}
.card__reader {
  width: 50px;
  height: 40px;
  background: radial-gradient(#fabc7b, #b48353);
  border-radius: 5px;
  position: absolute;
  top: 50px;
  left: 30px;
  overflow: hidden;
}
.card__reader--risk {
  width: 50px;
  height: 40px;
  border-radius: 13px;
  background: transparent;
  border: 1px solid #666;
  position: absolute;
  z-index: 0;
}
.card__reader--risk-one {
  transform: translate(37px, 15px);
}
.card__reader--risk-two {
  transform: translate(15px, 30px);
}
.card__reader--risk-three {
  transform: translate(-37px, -15px);
}
.card__reader--risk-four {
  transform: translate(-15px, -30px);
}
.user__email {
  font-size: 1.1em;
  font-weight: 600;
  color: #bb792d;
  letter-spacing: 0.5px;
  /* text-shadow: 0px 1px 0px rgb(215 147 70), 0px -1px 0px rgb(255 196 129); */
  /* filter: drop-shadow(3px 1px 3px #9d5f19); */
  z-index: 1;
  position: absolute;
  bottom: 45px;
  left: 25px;
  text-shadow: 0px 1px 0px rgb(215 147 70), 0px -1px 0px rgb(82 58 10);
}
.user__segment{
  font-size: 1.1em;
  font-weight: 600;
  color: #bb792d;
  letter-spacing: 0.5px;
  z-index: 1;
  position: absolute;
  bottom: 88px;
  left: 25px;
  text-shadow: 0px 1px 0px rgb(215 147 70), 0px -1px 0px rgb(82 58 10);
}
.user__name {
  font-size: 1.1em;
  font-weight: 600;
  color: #ffc98d;
  letter-spacing: 0.5px;
  text-shadow: 0px 1px 0px rgb(215 147 70), 0px -1px 0px rgb(255 196 129);
  filter: drop-shadow(3px 1px 3px #9d5f19);
  z-index: 1;
  position: absolute;
  bottom: 10px;
  left: 25px;
  /* text-shadow: 0px 1px 0px rgb(215 147 70), 0px -1px 0px rgb(82 58 10); */
}
  .card__type {
    font-size: 1.1em;
    font-weight: bold;
    color: white;
    letter-spacing: 1.5px;
    position: absolute;
    right: 33%;
    top: 29%;
    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.5));
  }
</style>